

































































import { Component, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { RequestMessage } from '@/types/_'
import _ from 'lodash'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { formatDateOnly, formatDateTimeSendApi } from '@/utils/common'

@Component
export default class ViewFinanceiroCargaLogs extends Vue {
  inputFiles: any[] = []
  exp: boolean = false

  get expand() {
    return this.exp
  }

  set expand(value: boolean) {
    this.exp = value
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get headers() {
    return this.getFinanceiroStore.logsTableHeader
  }


  get getLogs() {
    return this.getFinanceiroStore.cargaLogs
  }

  formatDateUtil(date: string) {
    return formatDateTimeSendApi(date)
  }

  async init() {
    await this.getFinanceiroStore.getLogs()
  }

  async mounted() {
    await this.init()
  }
}
